import { Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import type { RootState, AppDispatch } from '../app/redux/store'
import { fetchEnhancedUserInfo } from '../app/redux/slices/masterSubAccountSlice'

interface RequireAuthProps {
  children: React.ReactNode
}

export default function RequireAuth({ children }: RequireAuthProps) {
  const dispatch = useDispatch<AppDispatch>()
  const isAuthenticated = useSelector((state: RootState) => state.auth.authenticate)
  const isSubAccount = useSelector((state: RootState) => state.auth.isSubAccount)
  const allTeamsData = useSelector((state: RootState) => state.masterSubAccount.allTeamsData)

  // Ensure team data is loaded on every protected page, not just Dashboard/Teams
  useEffect(() => {
    if (isAuthenticated && !isSubAccount && allTeamsData === null) {
      dispatch(fetchEnhancedUserInfo())
    }
  }, [isAuthenticated, isSubAccount, allTeamsData, dispatch])

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}








